import { useState } from 'react';
import { floatingButtonStyles } from '@pm2/react-utils/selectors';
import { FloatingActionButton } from '@ui/kit';
import { ABCOrdbogenIcon, CrossIcon } from '@ui/kit/icons';
import { IsomorphicPortal, CSSRefTransition } from '@utils/react';
import { closeButton, transitionDurationMs, backdrop } from './_abc-ordbogen.style.js';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';

function ABCOrdbogenButton() {
  const [isOpen, setOpen] = useState(false);
  const handleOpenClick = () => {
    if (isOpen) {
      return;
    }
    window.toggleAbcWindow();
    setOpen(true);
  };
  const handleCloseClick = () => {
    if (!isOpen) {
      return;
    }
    window.toggleAbcWindow();
    setOpen(false);
  };
  return /*#__PURE__*/jsxs("div", {
    className: floatingButtonStyles.buttonWrapperCls,
    children: [/*#__PURE__*/jsx(FloatingActionButton, {
      tooltip: {
        ariaType: "label",
        placement: "left",
        body: /*#__PURE__*/jsx(Fragment, {
          children: "\xC5bn ordbog"
        })
      },
      disabled: isOpen,
      onClick: handleOpenClick,
      children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
        children: /*#__PURE__*/jsx(ABCOrdbogenIcon, {})
      })
    }), /*#__PURE__*/jsxs(IsomorphicPortal, {
      children: [/*#__PURE__*/jsx(CSSRefTransition, {
        in: isOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: transitionDurationMs,
        classNames: closeButton,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: closeButton,
          children: /*#__PURE__*/jsx(FloatingActionButton, {
            tooltip: {
              ariaType: "label",
              placement: "left",
              body: /*#__PURE__*/jsx(Fragment, {
                children: "Luk ordbog"
              })
            },
            onClick: handleCloseClick,
            children: /*#__PURE__*/jsx(FloatingActionButton.Icon, {
              children: /*#__PURE__*/jsx(CrossIcon, {
                height: "24",
                strokeWidth: 0.75
              })
            })
          })
        })
      }), /*#__PURE__*/jsx(CSSRefTransition, {
        in: isOpen,
        mountOnEnter: true,
        unmountOnExit: true,
        timeout: transitionDurationMs,
        classNames: backdrop,
        children: ref => /*#__PURE__*/jsx("div", {
          ref: ref,
          className: backdrop
        })
      })]
    })]
  });
}

export { ABCOrdbogenButton };
//# sourceMappingURL=_abc-ordbogen.js.map
